<div class="dorpel-wrapper container-fluid" [formGroup]="formGroup" *ngIf="formGroup">
  <div class="container bg-white py-4 my-4 rounded-4">
    <div class="row align-items-start">
      <div class="col">
        <label for="dorpeltype" class="form-label"><b>Dorpeltype:</b></label>
        <div>
          <select class="form-select" id="dorpeltype" formControlName="dorpel" (change)="setupNewConfiguration()">
            <option value="" disabled selected hidden>Selecteer een waarde a.u.b.</option>
            <option *ngFor="let dorpel of dorpels" value="{{ dorpel.dorpelCode }}">{{ dorpel.omschrijving }}</option>
          </select>
          <luv-validationError [show]="showError('dorpel')" [errorMessage]="errorMessage('dorpel')">
          </luv-validationError>
        </div>
      </div>
      <div class="col" *ngIf="isSlidingDorpel()" [ngStyle]="isDorpelConfigurationDisabled ? {'display': 'none'} : {}">
        <label for="schema" class="form-label">Schema:</label>
        <div>
          <select class="form-select" id="schema" formControlName="schema" (change)="setupNewConfiguration()">
            <option value="" disabled selected hidden>Selecteer een waarde a.u.b.</option>
            <option value="AL">Schema AL</option>
            <option value="AR">Schema AR</option>
            <option value="C+G">Schema C+G</option>
            <option value="D">Schema D</option>
          </select>
          <luv-validationError [show]="showError('schema')" [errorMessage]="errorMessage('schema')">
          </luv-validationError>
        </div>
      </div>
      <div class="col">
        <label class="form-label"><b>Aantal:</b></label>
        <div>
          <input type="number" class="form-control" aria-describedby="Aantal" formControlName="aantal" required integerOnly/>
          <luv-validationError [show]="showError('aantal')" [errorMessage]="errorMessage('aantal')">
          </luv-validationError>
        </div>
      </div>
      <div class="col">
        <label for="merk" class="form-label"><b>Merk:</b></label>
        <input type="text" class="form-control" id="merk" formControlName="merk" />
      </div>
      <div class="col">
        <label class="form-label"><b>Zaagmaat:</b></label>
        <div>
          <div class="input-group">
            <input type="number" class="form-control" aria-describedby="Zaagmaat" formControlName="zaagmaat"
              (change)="onZaagmaatValueChanged()" integerOnly/>
            <span class="input-group-text">mm</span>
          </div>
          <luv-validationError [show]="showError('zaagmaat')" [errorMessage]="errorMessage('zaagmaat')">
            <span *ngIf="zaagmaatTargetValue">Moet de zaagmaat <span class="link-aspect"
                (click)="fillZaagmaatTargetedValue()">{{this.zaagmaatTargetValue}}</span> zijn?</span>
          </luv-validationError>
        </div>

      </div>
      <div class="col" *ngIf="showAantalNeuten()"
        [ngStyle]="isDorpelConfigurationDisabled ? {'visibility': 'hidden'} : {}">
        <label for="aantalneuten" class="form-label"><b>Aantal Neuten:</b></label>
        <div>
          <select class="form-select" id="aantalneuten" formControlName="aantalNeuten"
            (change)="onNeutenCountChanged()">
            <option value="0">0</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
          </select>
          <luv-validationError [show]="showError('aantalNeuten')" [errorMessage]="errorMessage('aantalNeuten')">
          </luv-validationError>
        </div>
      </div>
      <div class="col" *ngIf="showAantalSluitpotten()"
        [ngStyle]="isDorpelConfigurationDisabled ? {'visibility': 'hidden'} : {}">
        <label for="aantalsluitpotten" class="form-label"><b>Aantal Sluitpotten:</b></label>
        <div>
          <input type="number" min="0" max="10" class="form-control form-control-sm" id="aantalsluitpotten"
            formControlName="aantalSluitpotten" (change)="onSluitpottenCountChanged()" integerOnly/>
          <luv-validationError [show]="showError('aantalSluitpotten')"
            [errorMessage]="errorMessage('aantalSluitpotten')">
          </luv-validationError>
        </div>
      </div>
      <!-- <div class="col">
        <label class="form-check-label" for="flexCheckDefault">
          <b>Einddoppen</b>
        </label><br>
        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
      </div> -->
    </div>
  </div>
  <div class="container-fluid bg-white py-4 my-4 rounded-4 text-center" *ngIf="!isDorpelConfigurationDisabled">
    <div class="drawing-wrapper" resizeListener (resizeEvent)="onDrawingWrapperResize()">
      <img *ngIf="isDrawingInExampleMode && exampleDrawingPath" [src]="exampleDrawingPath" alt="Example Drawing"
        class="example-drawing" />
      <canvas *ngIf="zaagmaatDependentFieldsEnabled" #dorpel_drawing id="dorpelDrawing" height="260"></canvas>
    </div>

    <div class="col-auto text-center drawing-controls" *ngIf="zaagmaatDependentFieldsEnabled">
      <button type="button" class="action-button btn btn-primary btn-lg px-4 gap-3 border-0 rounded-0"
        (click)="draw()"><b><i class="fas fa-paint-brush"></i> Opnieuw tekenen</b></button>
    </div>

    <div class="col-sm-auto text-center">
      <luv-validationError [show]="_sumOfMatenCustomError"
        [errorMessage]="_sumOfMatenCustomError"></luv-validationError>
    </div>
    <div class="col-sm-auto text-center" *ngIf="_slidingDoorsCustomErrors.neutValue">
      <span class="error-text">{{_slidingDoorsCustomErrors.neutValue}}</span>
    </div>
  </div>
</div>

<div [formGroup]="formGroup" *ngIf="formGroup">
  <div class="row mb-1 d-flex justify-content-center" *ngIf="isSlidingDorpel()"
    [ngStyle]="isDorpelConfigurationDisabled ? {'visibility': 'hidden'} : {}">

    <div class="col bg-white py-4 mx-2 rounded-4 restricted-size-panel">
      <label class="form-label"><b>Vak 1:</b></label>
      <div class="input-group">
        <input type="number" class="form-control" aria-describedby="maatA" formControlName="maatA"
          (change)="onMaatAChanged()" integerOnly/>
        <span class="input-group-text">mm</span>
      </div>
      <luv-validationError [show]="showError('maatA')" [errorMessage]="errorMessage('maatA')">
      </luv-validationError>
    </div>

    <div class="col bg-white py-4 mx-2 rounded-4 restricted-size-panel" *ngIf="showDeurmaatA()">
      <label class="form-label"><b>Deurmaat:</b></label>
      <div class="input-group">
        <input type="number" class="form-control" aria-describedby="deurmaatA" formControlName="deurmaatA"
          (change)="onDeurmaatAChanged()" integerOnly/>
        <span class="input-group-text">mm</span>
      </div>
      <luv-validationError [show]="showError('deurmaatA')" [errorMessage]="errorMessage('deurmaatA')">
      </luv-validationError>
      <luv-validationError [show]="_slidingDoorsCustomErrors.deurmaatA"
        [errorMessage]="_slidingDoorsCustomErrors.deurmaatA"></luv-validationError>
    </div>

    <div class="col bg-white py-4 mx-2 rounded-4 restricted-size-panel" *ngIf="showMaatA()">
      <label class="form-label"><b>Vak 2:</b></label>
      <div class="input-group">
        <input type="number" class="form-control" aria-describedby="maatA1" formControlName="firstMaatA"
          (change)="onFirstMaatAChanged()" integerOnly/>
        <span class="input-group-text">mm</span>
      </div>
      <luv-validationError [show]="showError('firstMaatA')" [errorMessage]="errorMessage('firstMaatA')">
      </luv-validationError>
      <luv-validationError [show]="_slidingDoorsCustomErrors.firstMaatA"
        [errorMessage]="_slidingDoorsCustomErrors.firstMaatA"></luv-validationError>
    </div>

    <div class="col bg-white py-4 mx-2 rounded-4 restricted-size-panel" *ngIf="showDeurmaatB()">
      <label class="form-label"><b>Deurmaat:</b></label>
      <div class="input-group">
        <input type="number" class="form-control" aria-describedby="deurmaatB" formControlName="deurmaatB"
          (change)="onDeurmaatBChanged()" integerOnly/>
        <span class="input-group-text">mm</span>
      </div>
      <luv-validationError [show]="showError('deurmaatB')" [errorMessage]="errorMessage('deurmaatB')">
      </luv-validationError>
      <luv-validationError [show]="_slidingDoorsCustomErrors.deurmaatB"
        [errorMessage]="_slidingDoorsCustomErrors.deurmaatB"></luv-validationError>
    </div>

    <div class="col bg-white py-4 mx-2 rounded-4 restricted-size-panel" *ngIf="showMaatB()">
      <label class="form-label"><b>Vak 2:</b></label>
      <div class="input-group">
        <input type="number" class="form-control" aria-describedby="maatB" formControlName="maatB"
          (change)="onMaatBChanged()" integerOnly/>
        <span class="input-group-text">mm</span>
      </div>
      <luv-validationError [show]="showError('maatB')" [errorMessage]="errorMessage('maatB')">
      </luv-validationError>
    </div>

    <div class="col bg-white py-4 mx-2 rounded-4 restricted-size-panel" *ngIf="showDeurmaatC()">
      <label class="form-label"><b>Deurmaat:</b></label>
      <div class="input-group">
        <input type="number" class="form-control" aria-describedby="deurmaatC" formControlName="deurmaatC"
          (change)="onDeurmaatCChanged()" integerOnly/>
        <span class="input-group-text">mm</span>
      </div>
      <luv-validationError [show]="showError('deurmaatC')" [errorMessage]="errorMessage('deurmaatC')">
      </luv-validationError>
      <luv-validationError [show]="_slidingDoorsCustomErrors.deurmaatC"
        [errorMessage]="_slidingDoorsCustomErrors.deurmaatC"></luv-validationError>
    </div>

    <div class="col bg-white py-4 mx-2 rounded-4 restricted-size-panel" *ngIf="showMaatC()">
      <label class="form-label"><b>Vak 3:</b></label>
      <div class="input-group">
        <input type="number" class="form-control" aria-describedby="maatC" formControlName="maatC"
          (change)="onMaatCChanged()" integerOnly/>
        <span class="input-group-text">mm</span>
      </div>
      <luv-validationError [show]="showError('maatC')" [errorMessage]="errorMessage('maatC')">
      </luv-validationError>
      <luv-validationError [show]="_slidingDoorsCustomErrors.maatC"
        [errorMessage]="_slidingDoorsCustomErrors.maatC"></luv-validationError>
    </div>

    <div class="col bg-white py-4 mx-2 rounded-4 restricted-size-panel">
      <label class="form-label"><b>{{getMaatZLabel()}}:</b></label>
      <div class="input-group">
        <input type="number" class="form-control" aria-describedby="maatZ" formControlName="maatZ"
          (change)="onMaatZChanged()" integerOnly/>
        <span class="input-group-text">mm</span>
      </div>
      <luv-validationError [show]="showError('maatZ')" [errorMessage]="errorMessage('maatZ')">
      </luv-validationError>
    </div>
  </div>
</div>

<!-- PRODUCTION-PATCH: remove all [ngStyle]="isDorpelConfigurationDisabled ? {'visibility': 'hidden'} : {}" once HS up to par -->